// extracted by mini-css-extract-plugin
export default {"jumbotron":"jumbotron1Style_jumbotron__uUEjv","input-container":"jumbotron1Style_input-container__dRT6u","form-control":"jumbotron1Style_form-control__dAvZG"};